import { useExtraInfo } from 'hooks';
import sortBy from 'lodash/sortBy';

/**
 * @description
 * Formats history questions to render on ui
 */
export const useHistoryQuestions = () => {
  const { historyQuestions } = useExtraInfo();

  const headerQuestions = historyQuestions?.filter((q) =>
    q.questionText.includes(q.questionGroupText)
  );
  const sortedHeaderQuestions = sortBy(headerQuestions, (o) => o.questionGroupId);
  const subQuestions = historyQuestions?.filter(
    (q) => q.questionText !== q.questionGroupText && q.questionGroupId === 2
  );
  const sortedSubQuestions = sortBy(subQuestions, (o) => o.questionId);

  return { sortedHeaderQuestions, sortedSubQuestions };
};
